// ** React Imports
import HoverVideoPlayer from "components/video/HoverVideoPlayer";

// ** Third Party Components
import styled, { css } from "styled-components";

// ** Custom Components
import StyledIcon from "components/global/StyledIcon/StyledIcon";
import { ReactComponent as PlaySolidIcon } from "resources/icons/solid/play-solid.svg";
import { StyledOverlay } from "styles/components/Overlay.styled";

// ** Custom Hooks
import useMobileDetect from "hooks/useMobileDetectHook";

// #####################################################

const StyledThumbnailImage = styled.img`
	height: 90px;
	width: 90px;
	display: flex;
	object-fit: cover;
	background-color: #303030;
	cursor: pointer;
	box-sizing: border-box;

	${({ isActive }) =>
		isActive &&
		css`
			border: 3px solid var(--dz-ref-color-white);
		`}
`;

// #####################################################

const ThumbnailMediaItemNew = ({ item, isActive }) => {
	// ** Hook useMobileDetect
	const mobileDetect = useMobileDetect();
	// ** Sprawdzamy czy użytkownik korzysta z urzadznie z systemem iOS
	const isIos = mobileDetect.isIos();

	const { media, media_type } = item || {};
	const { square, thumbs, video } = media || {};
	const { poster_square, preview_square } = thumbs || {};

	// ** Funkcja renderujaca Thumbnail Photo
	const renderImageThumbnail = () => (
		<>
			<StyledOverlay style={{ zIndex: 3 }} />
			<StyledThumbnailImage
				loading="lazy"
				src={square}
				isActive={isActive}
			/>
		</>
	);

	// ** Funkcja renderujaca Thumbnail Video
	const renderVideoThumbnail = ({ isActive }) => (
		<HoverVideoPlayer
			videoSrc={
				<>
					{preview_square && (
						<source src={preview_square} type="video/webm" />
					)}
					{video && <source src={video} type="video/mp4" />}
				</>
			}
			playbackStartDelay={100}
			playbackRangeEnd={isIos ? 5 : undefined}
			preload="none"
			loop
			unloadVideoOnPaused={true}
			sizingMode="overlay"
			style={{
				cursor: "pointer",
				height: "90px",
				display: "flex",
				objectFit: "cover",
				boxSizing: "border-box",
				overflow: isActive ? "hidden" : "visible",
				border: isActive
					? "3px solid var(--dz-ref-color-white)"
					: "none",
				backgroundColor: "#303030",
			}}
			hoverOverlay={<StyledOverlay />}
			pausedOverlay={
				<>
					<StyledOverlay style={{ zIndex: 3 }} />
					<StyledThumbnailImage loading="lazy" src={poster_square} />
					<StyledIcon size="modal_thumbnail" full noBackground>
						<PlaySolidIcon />
					</StyledIcon>
				</>
			}
		/>
	);

	// #####################################################
	return (
		<>
			{media_type === "photo"
				? renderImageThumbnail({ isActive })
				: media_type === "video"
				? renderVideoThumbnail({ isActive })
				: null}
		</>
	);
};

// #####################################################

export default ThumbnailMediaItemNew;

// #####################################################
